<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý Nhập xuất', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bwarehouse" class="soft-control">
        <div class="row p-1">
          <div class="col-md-12">
            <block :nobody="true" ref="chart">
              <date-range
                title="Thống kê xuất kho"
                v-model="daterange"
                class="mx-1"
              ></date-range>
              <hr class="m-0 mt-2" />
              <bar-chart
                class="m-2"
                :height="350"
                ref="barChart"
                :chart-data="chartData"
                :extra-options="extraOptions"
              ></bar-chart>
            </block>
          </div>
        </div>
        <b-row align-h="center">
          <b-col md="6">
            <b-alert show variant="info" class="text-center" block>
              <b style="font-size:20px"
                >TỔNG CỘNG : {{ $formatNumber(summarryAmount) }}</b
              >
            </b-alert>
          </b-col>
        </b-row>
        <hr />
        <b-row align-h="center">
          <b-col md="4">
            <b-button
              @click="openScannerTem"
              size="lg"
              block
              variant="primary"
              class="mb-3"
            >
              Nhập Kho
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button
              @click="returnGood"
              size="lg"
              block
              variant="primary"
              class="mb-3"
            >
              Trả Hàng
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="border-right border-info">
            <ReceiptIn class="mx-1"></ReceiptIn>
          </b-col>
          <b-col md="6" class="">
            <ReceiptOut class="mx-1"></ReceiptOut>
          </b-col>
        </b-row>
      </block>
    </div>
  </div>
</template>
<script>
import ReceiptIn from "./__ReceiptIn";
import ReceiptOut from "./__ReceiptOut";

import { receiptService } from "@/_services";
import { addDateTime } from "@/utils/date";

// import * as chartConfigs from "@/components/Charts/config";
import BarChart from "@/components/Charts/BarChart";

export default {
  name: "warehouse-manage",
  components: {
    ReceiptIn,
    ReceiptOut,
    BarChart
  },
  data() {
    return {
      listQuery: {
        page: 1,
        limit: 300,
        total: 0,
        from: addDateTime(-3),
        to: new Date()
      },
      chartData: {
        labels: [],
        datasets: []
      },
      extraOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                callback: value => {
                  return this.$formatNumber(value);
                }
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, chart) => {
              var datasetLabel =
                chart.datasets[tooltipItem.datasetIndex].label || "";
              return (
                datasetLabel + ": " + this.$formatNumber(tooltipItem.yLabel)
              );
            }
          }
        }
      },
      daterange: {},
      summarryAmount: 0
    };
  },
  mounted() {},
  methods: {
    fetchData() {
      this.listQuery.from = this.daterange.from;
      this.listQuery.to = this.daterange.to;
      this.$refs.chart.block();
      receiptService
        .report(this.listQuery)
        .then(res => {
          let tableData = res.data;
          let labels = [];
          let quantitys = [];
          let amounts = [];
          this.summarryAmount = 0;
          for (let i = 0; i < tableData.length; i++) {
            const element = tableData[i];
            if (element.type == "OUT") {
              labels.push(this.$dateUnix(element.dateCreated));
              quantitys.push(element.quantity);
              amounts.push(element.total);
              this.summarryAmount += element.total;
            }
          }
          let datasets = [];
          // datasets.push({
          //   label: "Tổng số lượng",
          //   data: quantitys
          // });
          datasets.push({ label: "Tổng tiền", data: amounts });

          this.chartData = {
            labels: labels,
            datasets: datasets
          };
          this.$refs.chart.unBlock();
        })
        .finally(() => {
          this.pending = false;
        });
    },
    openScannerTem() {
      this.$router.push({
        name: "scanner-tem"
      });
    },
    returnGood() {
      this.$router.push({
        name: "return-good"
      });
    }
  },
  watch: {
    daterange: function() {
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
